import {CARD_DATA_UPDATED} from '../shared/actions'

const initialState = {
    cardData: {
        card_number: '',
        card_expiration_month: '',
        card_expiration_year: '',
        security_code: '',
        card_holder_name: '',
        payment_method_id: null
    }
}

export const formInputData = (state = initialState, action) => {
    switch (action.type) {
        case CARD_DATA_UPDATED:
            const {key, value, paymentMethodId} = action.cardInfo

            let newState = {...state}

            newState.cardData[key] = value
            newState.cardData.payment_method_id = !!paymentMethodId ? paymentMethodId.toString() : null

            return newState;

        default:
            return state
    }
}
